import {
  BorderRadius,
  Colors,
  Media,
  Spacing,
  StackChildren,
} from '@doordash/design-language'
import styled from 'styled-components'

export const AddressFormContainer = styled(StackChildren)`
  padding: ${Spacing.XxSmall}px;

  ${Media.Mobile`
    height: 100%;
  `}
`
export const Bottom = styled.div`
  ${Media.Mobile`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: ${Spacing.XSmall}px ${Spacing.XSmall}px ${Spacing.XLarge}px;
  `}
`
